import axios from "axios";
import router from "@/router";
import Cookies from "js-cookie";


//axios的封装
const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,     //存放接口
    timeout: 5000
})

request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';

    //获取缓存数据,把token值传出
    const adminJson = Cookies.get('admin')
    if (adminJson) {
        //设置请求头
        config.headers['token'] = JSON.parse(adminJson).token
    }

    return config;
},error=>{
    return Promise.reject(error)
})


request.interceptors.response.use(
    response => {
        let res = response.data;
        if (typeof res === 'string'){         //如果返回的是字符串类型的话，进行json解析
            res = res ? JSON.parse(res) : res;
        }
        if (res.code === '401'){
            router.push('/login')
        }
        return res;
    },error => {
        console.log('err' + error)
        return Promise.reject(error)
    }

)

export default  request